import { Injectable } from '@angular/core';
import { FiBackendService } from '@fi-shared/fi-backend/fi-backend.service';
import { PostModel } from '@fi-shared/models';
import { cloneDeep } from '@fi-shared/utils';
import { LoadingService } from '@fi-shared/fi-loading/loading.service';

@Injectable()
export class PostService {
    constructor(
        private fiBackend: FiBackendService,
        private fiLoading: LoadingService,
    ) {}

    Save(post: PostModel) {
        // stripe unnecessary data
        const savePost = cloneDeep(post);
        savePost.MediaBankFileReferences.forEach(function (item) {
            if (item.Url) {
                delete item.Url;
            }
        });
        return this.fiBackend.fetchDataPost<number>('Post/Post/SavePost', savePost);
    }

    deletePost(id: number): Promise<void> {
        return this.fiLoading.trackPromise(this.fiBackend.fetchDataPost(`Post/Post/DeletePost/${id}`));
    }

    Get(id) {
        return this.fiBackend.fetchData(`Post/Post/GetPost/${id}`);
    }
}
